import PropTypes from 'prop-types';
import React from 'react';

function FileBlank(props) {
  const { fill } = props;
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.4942 2.97538L17.4942 2.97539L17.4975 2.97853L19.9975 5.38104C19.9979 5.38139 19.9982 5.38174 19.9986 5.3821C20.2391 5.6165 20.375 5.93915 20.375 6.27604V20.1235C20.375 20.8135 19.815 21.3735 19.125 21.3735H4.875C4.185 21.3735 3.625 20.8135 3.625 20.1235V3.87354C3.625 3.18354 4.185 2.62354 4.875 2.62354H16.625C16.9516 2.62354 17.2647 2.75157 17.4942 2.97538Z"
        fill="none"
        stroke={fill}
        strokeWidth="1.25"
      />
    </svg>
  );
}

FileBlank.propTypes = {
  fill: PropTypes.string.isRequired
};
export default FileBlank;
